import { render, staticRenderFns } from "./monitors.page.vue?vue&type=template&id=72bdbf08&scoped=true&"
import script from "./monitors.page.vue?vue&type=script&lang=js&"
export * from "./monitors.page.vue?vue&type=script&lang=js&"
import style0 from "./monitors.page.vue?vue&type=style&index=0&id=72bdbf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdbf08",
  null
  
)

export default component.exports